export enum Permission {
    None = -1,
    View = 0,
    Edit = 1,
}

export enum UserType {
    User = 'user',
    Finance = 'finance',
    Support = 'support',
}

// * Add to these consts, and they will be parsed automatically
// * into the Redux store from the Cognito token.
/**
 * All Cognito claims to be parsed as permissions.
 */
export const PERMISSION_KEYS = {
    prices: 'custom:PriceEditRole',
    uploading: 'custom:UploaderRole',
    stores: 'custom:StoreEditRole',
    products: 'custom:ProductEditRole',
    users: 'custom:UserEditRole',
} as const;

/**
 * All Cognito claims to be parsed as scope-rules.
 */
export const SCOPE_KEYS = {
    companies: 'custom:Companies',
    resellers: 'custom:Resellers',
    locations: 'custom:Locations',
} as const;
